/* "Start 14-day trial" is a <button> when it opens the popup; it keeps the
   look of the link class it's given. */
button.trial-btn {
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.nav-trial-short { display: none; }
@media (max-width: 480px) {
  .nav-trial-long { display: none; }
  .nav-trial-short { display: inline; }
}
